var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, ScrollView } from 'react-native';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { theme } from '@xbto/design-system';
import { TableHeader } from './header';
import { TableContent } from './content';
import { useBreakpoints } from '../../hooks';
import { Col } from '../../atoms';
export default function Table(_a) {
    var { data, columns, header, noHeader = false, backgroundInverted, onRowPressed, hideOnNoData = false, flatBorders = true } = _a, sortable = __rest(_a, ["data", "columns", "header", "noHeader", "backgroundInverted", "onRowPressed", "hideOnNoData", "flatBorders"]);
    /**
     * Vars
     */
    const { breakpoints } = useBreakpoints();
    /**
     * Hooks
     */
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });
    if (hideOnNoData && data.length === 0) {
        return null;
    }
    /**
     * DOM
     */
    return (_jsxs(ScrollView, { style: [
            $.scrollContainer,
            breakpoints.XS && flatBorders && $.scrollContainer_XS,
        ], horizontal: true, contentContainerStyle: $.scrollContentContainer, id: "scrollview", children: [header ? (_jsx(Col.LRC, { style: [$.addonHeader, breakpoints.LESS_THAN_M && $.addonHeaderSmall], children: header })) : null, _jsxs("table", { style: $.container, children: [!noHeader && _jsx(TableHeader, Object.assign({}, sortable, { table: table })), _jsx(TableContent, { table: table, backgroundInverted: backgroundInverted, onRowPressed: onRowPressed })] })] }));
}
const $ = StyleSheet.create({
    scrollContainer: {
        borderRadius: Number(theme.radius.md),
        borderColor: theme.color.border.primary,
        borderWidth: 1,
    },
    scrollContainer_XS: {
        marginRight: -theme.spacing['4'],
        marginLeft: -theme.spacing['4'],
        borderRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
    },
    scrollContentContainer: {
        flexDirection: 'column',
        alignItems: 'stretch',
        minWidth: '100%',
    },
    addonHeader: {
        backgroundColor: theme.color.background.tertiary,
        borderBottomColor: theme.color.border.primary,
        borderBottomWidth: 1,
        paddingVertical: theme.spacing['3'],
        paddingHorizontal: theme.spacing['6'],
    },
    addonHeaderSmall: {
        paddingHorizontal: theme.spacing['4'],
    },
    container: {
        // @ts-expect-error This is web only
        tableLayout: 'auto',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        backgroundColor: theme.color.background.white,
    },
});
